import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface SectionHeaderProps {
  title: string;
  count?: number;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function SectionHeader({ title, count, action, children, className }: SectionHeaderProps) {
  return (
    <div className={clsx('flex items-center justify-between gap-3', className)}>
      <div className="flex items-center gap-2">
        <h2 className="text-2xs font-semibold uppercase tracking-wider text-ink-dim">{title}</h2>
        {count !== undefined && (
          <span className="inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-surface-3 px-1.5 text-2xs font-semibold tabular-nums text-ink-muted">
            {count}
          </span>
        )}
      </div>
      <div className="flex items-center gap-2">
        {children}
        {action}
      </div>
    </div>
  );
}
